"use client";

import React, { useState, useEffect } from "react";

export const Footer = () => {
  const [year, setYear] = useState(new Date().getFullYear());

  useEffect(() => {
    setYear(new Date().getFullYear());
  }, []);

  return (
    <footer className="flex flex-col bg-background w-full justify-center items-center text-sm px-4">
      <div className="w-full my-2">
        <div className="text-sm">
          <h4>Reference:</h4>
          <ul className="">
            <li>
              <p>
                This project uses code from{" "}
                <a
                  href="https://bbycroft.net/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Brendan Bycroft
                </a>
                . Thank you for your contributions!
              </p>
            </li>
          </ul>
        </div>
      </div>

      <div className="my-2">
        <a
          href="https://www.capabara.com/"
          target="_blank"
          rel="noreferrer"
          className="!text-inherit"
        >
          CAPABARA
        </a>
        &nbsp;@ {year} Created by&nbsp;
        <a
          href="https://www.straitsinteractive.com/"
          target="_blank"
          rel="noreferrer"
          className="!text-inherit"
        >
          Straits Interactive
        </a>
        &nbsp;Pte Ltd.
      </div>
    </footer>
  );
};
